import { render, staticRenderFns } from "./CollectionLinkedFileAddForm.vue?vue&type=template&id=1a9c308f&scoped=true"
import script from "./CollectionLinkedFileAddForm.vue?vue&type=script&lang=js"
export * from "./CollectionLinkedFileAddForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionLinkedFileAddForm.vue?vue&type=style&index=0&id=1a9c308f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c308f",
  null
  
)

export default component.exports